// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1gYfCMI2AInXBKF5L8xM9t {\n  height: 104px;\n}\n\n.MgghxGIAAksf2IK3pCF9- {\n  position: absolute;\n  top: 5px;\n  width: 32px;\n  left: 0;\n}\n\n._1CrwLR57LgONsnEd4rqEI7 {\n  position: absolute;\n  bottom: 5px;\n  width: 32px;\n  left: 0;\n}\n\n._2SCHuXHH0CL-t7o9_rIPT4 {\n  position: absolute;\n  width: 32px;\n  left: 0;\n  margin-top: -7.5px;\n}\n", ""]);
// Exports
exports.locals = {
	"stateBtn": "_1gYfCMI2AInXBKF5L8xM9t",
	"state-success": "MgghxGIAAksf2IK3pCF9-",
	"state-danger": "_1CrwLR57LgONsnEd4rqEI7",
	"state-default": "_2SCHuXHH0CL-t7o9_rIPT4"
};
module.exports = exports;
